import { useContext, useState } from 'react'
import { BiFullscreen, BiHelpCircle } from 'react-icons/bi'
import { BsFillMoonFill, BsFillSunFill } from 'react-icons/bs'
import { FiMenu } from 'react-icons/fi'
import { IoClose } from 'react-icons/io5'
import { TbZoomMoney } from 'react-icons/tb'
import { VscGear } from 'react-icons/vsc'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { ModalTotalContext } from '../../../context/ModalContext'
import logoTiny from '../../../icons/logo-RGB-39.png'
import Profile from '../../../icons/profile.jpg'
import { breakpoints } from '../../../MediasQueries'
import {
  AccountTitle,
  ButtonFunction,
  ButtonToggle,
  Config,
  ContainerInitial,
  ContainerNav,
  Item,
  ListItems,
  Logo,
  ProfileDiv,
  ProfileImage,
  Title,
  TitleConfig,
} from './style'
const TopInfo = ({ theme, toggle }) => {
  const navigate = useNavigate()
  const { user } = useContext(AuthContext)
  const { openModal, setOpenModal } = useContext(ModalTotalContext)
  const isDesktop = useMediaQuery({ minWidth: breakpoints.lg })
  const [over, setOver] = useState(null)
  return (
    <ContainerInitial>
      {!isDesktop && (
        <>
          <Logo src={logoTiny} alt="logo" />
          <ButtonFunction
            menu
            onClick={() => (openModal === 'Menu' ? setOpenModal(null) : setOpenModal('Menu'))}
          >
            {openModal === 'Menu' && <IoClose className="menu" />}
            {!(openModal === 'Menu') && <FiMenu className="menu" />}
          </ButtonFunction>
        </>
      )}

      <ContainerNav>
        {theme.title == 'dark' ? (
          <ButtonToggle onClick={() => toggle()}>
            <BsFillMoonFill className="iconFunc moon"></BsFillMoonFill>
          </ButtonToggle>
        ) : (
          <ButtonToggle className="checked" onClick={() => toggle()}>
            <BsFillSunFill className="iconFunc moon"></BsFillSunFill>
          </ButtonToggle>
        )}
        {isDesktop && (
          <ButtonFunction>
            <BiFullscreen className="iconFunc" />
          </ButtonFunction>
        )}

        <ButtonFunction>
          <BiHelpCircle className="iconFunc" />
        </ButtonFunction>
        <ButtonFunction onMouseLeave={() => setOver(null)} onMouseOver={() => setOver('config')}>
          <VscGear className="iconFunc" />
        </ButtonFunction>
      </ContainerNav>
      <ProfileImage src={Profile} alt="profile" />
      <ProfileDiv>
        <Title>{user?.nome || 'Usuário Teste'}</Title>
        <AccountTitle>Conta Teste</AccountTitle>
      </ProfileDiv>

      <Config over={over}>
        <TitleConfig>Configuração</TitleConfig>
        <ListItems>
          <Item onClick={() => navigate('/expenses')}>
            <TbZoomMoney />
            Definição de despesas
          </Item>
        </ListItems>
      </Config>
    </ContainerInitial>
  )
}
export default TopInfo
